import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, BusinessType, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { FeeDefinition } from './fee-definition.entity';
import { FeeEntityType } from './fee.entity-type.enum';
import { FeeStatus } from './fee.status.enum';
import { FeeType } from './fee.type.enum';
export const FeeSchema = WithBaseEntitySchema(
    z.object({
        entityId: z.string().optional(),
        entityType: EnumSchema(FeeEntityType),
        buyer: z.string().optional(),
        business: z.string(),
        businessType: EnumSchema(BusinessType),
        feeDefinition: z.string(),
        amount: z.number(),
        currency: EnumSchema(Currency),
        status: EnumSchema(FeeStatus),
        type: EnumSchema(FeeType),
    }),
).strict();

export class Fee extends FromSchema(FeeSchema) implements BaseEntity {
    id: string;
    entityId?: string;
    entityType: FeeEntityType;
    buyer?: string;
    business: string;
    businessType: BusinessType;
    feeDefinition: string | FeeDefinition;
    amount: number;
    currency: Currency;
    status: FeeStatus;
    type: FeeType;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
